// React Core
import React, { useEffect, useState } from "react";

// Components
import AboutTemple from "./components/aboutTemple/AboutTemple";
import DailySchedule from "./components/dailySchedule/DailySchedule";
import Gallery from "./components/homeGallery/Gallery";
import LatestUpdates from "./components/latestupdates/LatestUpdates";
import Panchangam from "./components/panchangam/Panchangam";
import Services from "./components/homeServices/Services";
import Slider from "./components/slider/Slider";
import Templetime from "./components/temple-time/Templetime";
import UpcommingEvents from "./components/upcomingEvent/UpcomingEvents";
import FloatingSidemenu from "./components/floatingmenu/FloatingSidemenu";

// Custom Hooks
import useLoadMasterDataHome from "./customHooks";

// Material-UI
import { Grid } from "@mui/material";

// JSON
import templeJson from "../../config/temple.json";
import News from "./components/homeNews/homeNews";
import Events from "./components/homeEvents/homeEvents";
import Spotlight from "./components/spotlight/Sportlight";

function Home() {
  const { masterData, getMasterData, gallery } = useLoadMasterDataHome();

  useEffect(() => {
    getMasterData();
  }, []);

  const components = {
    Slider: <Slider />,
    LatestUpdates: <LatestUpdates />,
    schedule: <DailySchedule />,
    upcomingEvents: <UpcommingEvents />,
    news: <News />,
    event: <Events />,
    services: <Services services={masterData.services} />,
    Spotlight: <Spotlight spotlight={masterData.spotlight} />,
    aboutTemple: <AboutTemple templeMission={masterData.templeMission} />,
    Panchangam: <Panchangam dailyPanchang={masterData.dailyPanchangam} />,
    gallery: <Gallery gallery={gallery} />,
    templeTiming: <Templetime />,
    floatingSideMenu: (
      <FloatingSidemenu
        liveStreamingUrlData={masterData?.liveStreamingUrlData}
      />
    ),
  };

  return (
    <>
      {templeJson?.pages["Home"].components?.map((component, index) =>
        component?.enabled == true && component?.sectionItems ? (
          <Grid container spacing={2} key={index} sx={{ overflow: "hidden" }}>
            {component.sectionItems.map((item, itemIndex) => (
              <Grid
                item
                xs={item?.xs}
                sm={item?.sm}
                md={item?.md}
                key={itemIndex}
                className={item?.className ? item?.className : ""}
              >
                {components[item?.name]}
              </Grid>
            ))}
          </Grid>
        ) : (
          component?.enabled == true && (
            <Grid container spacing={1} key={index}>
              <Grid item xs={12} sm={12} md={12}>
                {components[component?.name]}
              </Grid>
            </Grid>
          )
        )
      )}
    </>
  );
}

export default Home;
